// Import external libraries
import { createStore, applyMiddleware, compose } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createEpicMiddleware } from 'redux-observable';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import WalletTransform from '../redux/wallet/persistTransform';
import TransactionTransform from '../redux/transaction/persistTransform';
// Epic
import rootEpic from './epics.index';

// Import reducers
import { rootReducer } from './reducer.index';

// Firebase
import firebase from 'firebase/app';
import 'firebase/firestore';

// Initialize firebase
const firebaseConfig = {
    apiKey: 'AIzaSyDhRL8c6RjpCTLKY-zOT5JUXIJBzqPiVJc',
    authDomain: 'bis-hub-d4337.firebaseapp.com',
    projectId: 'bis-hub-d4337',
    storageBucket: 'bis-hub-d4337.appspot.com',
    messagingSenderId: '12097081913',
    appId: '1:12097081913:web:953920ae47c16f9e66b3e8',
};

firebase.initializeApp(firebaseConfig);

// Add redux observable
const epicMiddleware = createEpicMiddleware({ dependencies: { firebase } });

const persistConfig = {
    key: 'bishub_wallet',
    storage,
    transforms: [WalletTransform, TransactionTransform],
    blacklist: ['addressbook'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Export store
export const store = createStore(
    persistedReducer,
    composeWithDevTools(applyMiddleware(epicMiddleware)),
);

export const persistor = persistStore(store);

// Start epic middleware
epicMiddleware.run(rootEpic);
